import React from 'react';
import { Dialog, DialogContent, Grid, Typography } from '@mui/material';

import DisplayDifferences from './DisplayDifferences';
import { CloseButton, AcceptButton } from './styles';

const BookingValuationChangesModal = ({
  /** modal */
  open,

  /** data */
  valuationChanges,
  business_types,
  integration,

  /** pricing / display */
  supplier,
  compare,
  id_product,
  total_nights,
  total_passangers,
  check_in,
  isFromHotelBookingStyled,

  /** tooltips */
  usdUserTooltip,
  setUsdUserTooltip,
  priceTooltip,
  setPriceTooltip,
  handleMouseEnter,
  handleMouseLeave,

  /** actions */
  onCancel,
  onConfirm,
  onAcept,

  aceptText = 'Aceptar',

  acceptOnly,
}) => {
  const sharedProps = {
    supplier,
    compare,
    id_product,
    total_nights,
    total_passangers,
    check_in,
    isFromHotelBookingStyled,

    usdUserTooltip,
    setUsdUserTooltip,
    priceTooltip,
    setPriceTooltip,
    handleMouseEnter,
    handleMouseLeave,
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={(_, reason) => {
        // Bloqueamos backdrop y escape
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
    >
      <DialogContent>
        <Grid container direction="column">
          <Grid item xs={12}>
            <Typography
              sx={{
                color: '#000',
                fontWeight: 600,
                fontSize: 20,
                textAlign: 'center',
              }}
            >
              Se encontraron los siguientes cambios
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <DisplayDifferences
              modifiedObj={valuationChanges}
              business_types={business_types}
              integration={integration}
              {...sharedProps}
            />
          </Grid>

          {acceptOnly ? (
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 2,
              }}
            >
              <CloseButton onClick={onAcept}>{aceptText}</CloseButton>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 2,
                alignItems: 'center',
              }}
            >
              <CloseButton variant="contained" onClick={onCancel}>
                Volver
              </CloseButton>

              <AcceptButton variant="contained" onClick={onConfirm}>
                Aceptar
              </AcceptButton>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default BookingValuationChangesModal;
